import React from 'react';
import { Alert, Text } from '@zillow/constellation';

const NotViewableMessage = (props) => {
    const { feedName, feedId } = props;
    const content = `You can manage 3D tours on this page. Other listing details, such as pricing
    and availability, are updated through a feed. To edit those details, return to ${feedName || feedId}.`;
    return (
        <Alert
            appearance="info"
            body={<Text fontType="body">{content}</Text>}
        />
    );
};

export default NotViewableMessage;
